// export const genders = [
//     {id: 1, name: 'Male'},
//     {id: 2, name: 'Female'},
//     {id: 3, name: 'Other'}
// ];


import { apiCall } from "../helpers/api";


export const gender = (params = {}) => (dispatch) => {
  params.path = params.path || "lookup/genders";
  return dispatch(apiCall(params));
}